import { render, staticRenderFns } from "./CrmSynchronization.vue?vue&type=template&id=394790b8&"
import script from "./CrmSynchronization.vue?vue&type=script&lang=js&"
export * from "./CrmSynchronization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports